export default __webpack_public_path__ + "static/media/cliniter-mark.040df17c.png";